const routes = all_routes;

import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import { all_routes } from "./all_routes";

// 💤 Lazy-loaded components
const PartsModels = lazy(() =>
  import("../feature-module/inventory/partsmodels")
);
const ProductList = lazy(() =>
  import("../feature-module/inventory/productlist")
);
const AddProduct = lazy(() => import("../feature-module/inventory/addproduct"));
const LowStock = lazy(() => import("../feature-module/inventory/lowstock"));
const CategoryList = lazy(() =>
  import("../feature-module/inventory/categorylist")
);
const Managestock = lazy(() => import("../feature-module/stock/managestock"));
const SalesReport = lazy(() => import("../feature-module/Reports/salesreport"));
const PurchaseReport = lazy(() =>
  import("../feature-module/Reports/purchasereport")
);
const InventoryReport = lazy(() =>
  import("../feature-module/Reports/inventoryreport")
);
const CustomerReport = lazy(() =>
  import("../feature-module/Reports/customerreport")
);
const ExpenseReport = lazy(() =>
  import("../feature-module/Reports/expensereport")
);
const IncomeReport = lazy(() =>
  import("../feature-module/Reports/incomereport")
);
const TaxReport = lazy(() => import("../feature-module/Reports/taxreport"));
const ProfitLoss = lazy(() => import("../feature-module/Reports/profitloss"));
const SalesReturn = lazy(() => import("../feature-module/sales/salesreturn"));
const Profile = lazy(() => import("../feature-module/pages/profile"));
const Signin = lazy(() => import("../feature-module/pages/login/signin"));
const Forgotpassword = lazy(() =>
  import("../feature-module/pages/forgotpassword/forgotpassword")
);
const NewDashboard = lazy(() =>
  import("../feature-module/dashboard/newDashboard")
);
const AllOrdes = lazy(() =>
  import("../feature-module/sales/online-order/AllOrdes")
);
const Invoice = lazy(() => import("../feature-module/sales/invoicereport"));
const Invoicedetails = lazy(() =>
  import("../feature-module/sales/invoicedetails")
);
const Stockhistory = lazy(() =>
  import("../feature-module/Reports/stockhistory")
);
const SoldStock = lazy(() => import("../feature-module/Reports/soldstock"));
const Productreport = lazy(() =>
  import("../feature-module/Reports/productreport")
);
const ProductExpiredreport = lazy(() =>
  import("../feature-module/Reports/products-report/productexpiredreport")
);
const ProductQualityreport = lazy(() =>
  import("../feature-module/Reports/products-report/productqualityreport")
);
const Activities = lazy(() => import("../feature-module/pages/activities"));
const AddCategory = lazy(() =>
  import("../feature-module/inventory/addcategory")
);
const AddCustomer = lazy(() =>
  import("../feature-module/inventory/addcustomer")
);
const CustomerList = lazy(() =>
  import("../feature-module/inventory/customerlist")
);
const Shop = lazy(() => import("../feature-module/inventory/shop"));
const AddUser = lazy(() => import("../feature-module/inventory/adduser"));
const Accounting = lazy(() => import("../feature-module/inventory/accounting"));
const Orderhistory = lazy(() =>
  import("../feature-module/inventory/Orderhistory")
);
const NewOrders = lazy(() =>
  import("../feature-module/sales/online-order/NewOrders")
);
const Addvendor = lazy(() => import("../feature-module/inventory/addvendor"));
const Addstocks = lazy(() => import("../feature-module/stock/addstocks"));
const Printstockdata = lazy(() =>
  import("../feature-module/stock/printstockdata")
);
const Discount = lazy(() => import("../feature-module/Discount/Discount"));
const Stockissues = lazy(() => import("../feature-module/stock/Stockissues"));
const VendorReport = lazy(() =>
  import("../feature-module/Reports/vendorReport")
);
const AddCatelog = lazy(() => import("../feature-module/inventory/addcatelog"));
const AddPartsModels = lazy(() =>
  import("../feature-module/inventory/addpartsmodels")
);
const TransportList = lazy(() =>
  import("../feature-module/inventory/transportlist")
);
const AddTransport = lazy(() =>
  import("../feature-module/inventory/addtransport")
);
const CatelogList = lazy(() =>
  import("../feature-module/inventory/cateloglist")
);
const BrandList = lazy(() => import("../feature-module/inventory/brandlist"));
const Product = lazy(() => import("../feature-module/inventory/products"));
const Inventory = lazy(() => import("../feature-module/inventory/Inventory"));
const Pos = lazy(() => import("../POS/POS"));

export const publicRoutes = [
  {
    id: 1,
    path: routes.newdashboard,
    name: "home new",
    element: <NewDashboard />,
    route: Route,
  },
  {
    id: 2,
    path: routes.partlist,
    name: "part-list",
    element: <ProductList />,
    route: Route,
  },
  {
    id: 3,
    path: routes.categorylist,
    name: "categorylist",
    element: <CategoryList />,
    route: Route,
  },
  {
    id: 4,
    path: routes.customerlist,
    name: "customer-list",
    element: <CustomerList />,
    route: Route,
  },
  {
    id: 5,
    path: routes.shop,
    name: "shop",
    element: <Shop />,
    route: Route,
  },
  {
    id: 6,
    path: routes.addpart,
    name: "padd-part",
    element: <AddProduct />,
    route: Route,
  },
  {
    id: 7,
    path: routes.addcategory,
    name: "add-category",
    element: <AddCategory />,
    route: Route,
  },
  {
    id: 8,
    path: routes.addcustomer,
    name: "add-customer",
    element: <AddCustomer />,
    route: Route,
  },
  {
    id: 9,
    path: routes.adduser,
    name: "add-user",
    element: <AddUser />,
    route: Route,
  },
  {
    id: 10,
    path: routes.managestock,
    name: "managestock",
    element: <Managestock />,
    route: Route,
  },
  {
    id: 11,
    path: routes.lowstock,
    name: "lowstock",
    element: <LowStock />,
    route: Route,
  },
  {
    id: 12,
    path: routes.allorder,
    name: "all-order",
    element: <AllOrdes />,
    route: Route,
  },
  {
    id: 13,
    path: routes.invoice,
    name: "invoice",
    element: <Invoice />,
    route: Route,
  },
  {
    id: 14,
    path: routes.invoicedetails,
    name: "invoice-details",
    element: <Invoicedetails />,
    route: Route,
  },
  {
    id: 15,
    path: routes.salesreturn,
    name: "salesreturn",
    element: <SalesReturn />,
    route: Route,
  },
  {
    id: 16,
    path: routes.salesreport,
    name: "salesreport",
    element: <SalesReport />,
    route: Route,
  },
  {
    id: 17,
    path: routes.purchasereport,
    name: "purchasereport",
    element: <PurchaseReport />,
    route: Route,
  },
  {
    id: 18,
    path: routes.inventoryreport,
    name: "inventoryreport",
    element: <InventoryReport />,
    route: Route,
  },
  {
    id: 19,
    path: routes.stockhistory,
    name: "stock-history",
    element: <Stockhistory />,
    route: Route,
  },
  {
    id: 20,
    path: routes.soldstock,
    name: "sold-stock",
    element: <SoldStock />,
    route: Route,
  },
  {
    id: 21,
    path: routes.customerreport,
    name: "customerreport",
    element: <CustomerReport />,
    route: Route,
  },
  {
    id: 22,
    path: routes.productreport,
    name: "product-report",
    element: <Productreport />,
    route: Route,
  },
  {
    id: 23,
    path: routes.productexpiredreport,
    name: "product-expired-report",
    element: <ProductExpiredreport />,
    route: Route,
  },
  {
    id: 24,
    path: routes.productquantityreport,
    name: "product-quality-report",
    element: <ProductQualityreport />,
    route: Route,
  },
  {
    id: 25,
    path: routes.expensereport,
    name: "expensereport",
    element: <ExpenseReport />,
    route: Route,
  },
  {
    id: 26,
    path: routes.incomereport,
    name: "incomereport",
    element: <IncomeReport />,
    route: Route,
  },
  {
    id: 27,
    path: routes.taxreport,
    name: "taxreport",
    element: <TaxReport />,
    route: Route,
  },
  {
    id: 28,
    path: routes.profitloss,
    name: "profitloss",
    element: <ProfitLoss />,
    route: Route,
  },
  {
    id: 29,
    path: routes.activities,
    name: "activities",
    element: <Activities />,
    route: Route,
  },
  {
    id: 30,
    path: routes.profile,
    name: "profile",
    element: <Profile />,
    route: Route,
  },
  {
    id: 31,
    path: "*",
    name: "NotFound",
    element: <Navigate to="/index" />,
    route: Route,
  },
  {
    id: 32,
    path: routes.orderhistory,
    name: "OrderHistory",
    element: <Orderhistory />,
    route: Route,
  },
  {
    id: 33,
    path: routes.accounting,
    name: "Accounting",
    element: <Accounting />,
    route: Route,
  },
  {
    id: 34,
    path: routes.neworders,
    name: "New Orders",
    element: <NewOrders />,
    route: Route,
  },
  {
    id: 35,
    path: routes.addvendors,
    name: "Vendors",
    element: <Addvendor />,
    route: Route,
  },
  {
    id: 36,
    path: routes.addstocks,
    name: "Add Stocks",
    element: <Addstocks />,
    route: Route,
  },
  {
    id: 37,
    path: routes.purchaseorder,
    name: "Purchase Order",
    element: <Printstockdata />,
    route: Route,
  },
  {
    id: 38,
    path: routes.discounts,
    name: "Discounts",
    element: <Discount />,
    route: Route,
  },
  {
    id: 39,
    path: routes.stockissue,
    name: "Stock Issue",
    element: <Stockissues />,
    route: Route,
  },
  {
    id: 40,
    path: routes.vendorreport,
    name: "Vendor Report",
    element: <VendorReport />,
    route: Route,
  },

  {
    id: 42,
    path: routes.customernquiry,
    name: "Franchise Enquiry",
    element: <customernquiry />,
    route: Route,
  },
  {
    id: 43,
    path: routes.dashboard,
    name: "home new",
    element: <NewDashboard />,
    route: Route,
  },
  {
    id: 44,
    path: routes.addcatelog,
    name: "Add Catelog",
    element: <AddCatelog />,
    route: Route,
  },
  {
    id: 45,
    path: routes.transportlist,
    name: "Transport List",
    element: <TransportList />,
    route: Route,
  },
  {
    id: 46,
    path: routes.addtransport,
    name: "Add Transport",
    element: <AddTransport />,
    route: Route,
  },
  {
    id: 47,
    path: routes.cateloglist,
    name: "Catelog List",
    element: <CatelogList />,
    route: Route,
  },
  {
    id: 48,
    path: routes.brandlist,
    name: "Brand List",
    element: <BrandList />,
    route: Route,
  },
  {
    id: 49,
    path: routes.product,
    name: "Product",
    element: <Product />,
    route: Route,
  },
  {
    id: 50,
    path: routes.inventory,
    name: "Inventory",
    element: <Inventory />,
    route: Route,
  },
  {
    id: 67,
    path: routes.partsmodels,
    name: "Part Models",
    element: <PartsModels />,
    route: Route,
  },
  {
    id: 68,
    path: routes.addpartsmodels,
    name: "Add Parts Model",
    element: <AddPartsModels />,
    route: Route,
  },
];

export const pagesRoute = [
  {
    id: 1,
    path: routes.signin,
    name: "signin",
    element: <Signin />,
    route: Route,
  },
  {
    id: 2,
    path: routes.forgotPassword,
    name: "forgotPassword",
    element: <Forgotpassword />,
    route: Route,
  },
];

export const posRoutes = [
  {
    id: 1,
    path: routes.pos,
    name: "POS Page",
    element: <Pos />,
    route: Route,
  },
];
